import React, { useContext, useState } from 'react'
import '../index.scss'
import { ICONS } from '@Const/common'
import { observer } from 'mobx-react'
import ModalPortal from '@Components/Popups/ModalPortal'
import { setItemToArrayByIndex } from '@App/helpers/work-entities/removers'
import { canAmend } from '@App/helpers/permission'
import { StoresContext } from '@App/contexts'
import { WorkModel } from '@Entities/work/work'
import WriterLabels from './WriterLabels'
import WriterSideBar from './WriterSideBar'

import RootStore from '@App/stores/root-store'
import { PublisherModel } from '@Entities/work/publisher-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'
import { WriterModel } from '@Entities/work/writer-model'

interface OriginalPublisherCardAddWritersProps {
    data: OriginalPublisherModel

    removeFunc?(data: PublisherModel): void
}

const OriginalPublisherCardAddWriters = (props: OriginalPublisherCardAddWritersProps) => {
    const { data, removeFunc } = props

    const { workStore } = useContext<RootStore>(StoresContext)
    const [sidebarIsOpen, setSidebarIsOpen] = useState<boolean>(false)
    const [workWriters, setWorkWriters] = useState<WriterModel[]>([])

    const removeWriter = (removingWriter: WriterModel) => {
        const workDraftFromLocal = workStore.workDraftLocal
        const editingOPId = data.localId

        if (!workDraftFromLocal || !editingOPId || !removingWriter) {
            return
        }

        const originalPublishers = workDraftFromLocal.originalPublishers
        const indexOfOP = originalPublishers.map((op: OriginalPublisherModel) => op.localId).indexOf(editingOPId)

        const updatedWriters: WriterModel[] = data.writers.filter((writer: WriterModel) => {
            if (removingWriter.localId === writer.localId) {
                return
            }
            return writer
        })

        const updatedOriginalPublisher: OriginalPublisherModel = {
            id: data.id,
            amend: data.amend,
            localId: editingOPId,
            publisherName: data.publisherName,
            ipiNumber: data.ipiNumber,
            publisherShare: data.publisherShare,
            administratorPublishers: data.administratorPublishers,
            writers: updatedWriters,
        }

        const updatedOPArray = setItemToArrayByIndex(originalPublishers, +indexOfOP, updatedOriginalPublisher)

        const updatedWorkDraft: WorkModel = {
            ...workDraftFromLocal,
            originalPublishers: updatedOPArray,
        }
        workStore.setWorkDraftToLocal(updatedWorkDraft)
        const newWorkWriters = [...workWriters, removingWriter]
        setWorkWriters(newWorkWriters)
    }

    return (
        <div className="original-publisher-card">
            <div className="head">
                <p className="bold">{data.publisherName}</p>
                <div className="controls">
                    {removeFunc && (
                        <span className="small-2 medium" onClick={() => removeFunc(data)}>
                            Remove
                        </span>
                    )}
                </div>
            </div>
            <div className="content">
                <p className="small">
                    IPI: <strong>{data.ipiNumber}</strong>
                </p>
                {!data.administratorPublishers.length && data.publisherShare !== null && (
                    <>
                        <p className="small">Publisher share:</p>
                        <h1 className="percent">{data.publisherShare ? data.publisherShare : 0}</h1>
                    </>
                )}
                <p className="small">Represented Writers:</p>
                <div className="represented-writers-container">
                    {canAmend(data.amend) && (
                        <div className="item add" onClick={() => setSidebarIsOpen(true)}>
                            <p className="bold small-2">Add writer</p>
                            <div className="button">
                                <img src={ICONS.add} alt="add" />
                            </div>
                        </div>
                    )}
                    <WriterLabels
                        linkedWriters={data.writers}
                        isAmendable={canAmend(data.amend)}
                        removeWriter={removeWriter}
                    />
                </div>
            </div>
            <ModalPortal isOpen={sidebarIsOpen} onClose={() => setSidebarIsOpen(false)}>
                <WriterSideBar data={data} />
            </ModalPortal>
        </div>
    )
}

export default observer(OriginalPublisherCardAddWriters)
